export default __webpack_public_path__ + "assets/9689f4d97490c0b294a39288effb775f.svg";